module.exports = __webpack_public_path__ + "static/Foursquare_logo-b1a6f2c6377a5281cd685c7d7c716c25.png";